import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { listFAQs } from "../../Redux/Actions/FaqAction";
import Loading from "../LoadingError/Loading";
import Message from "../LoadingError/Error";
import Faq from "../faqs/Faq";
import { Button, Heading } from "@chakra-ui/react";

const MainFaq = () => {
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);

    const faqList = useSelector((state) => state.faqList);
    const { loading, error, faq, totalPages } = faqList;

    const faqDelete = useSelector((state) => state.faqDelete);
    const { error: errorDelete, success: successDelete } = faqDelete;

    useEffect(() => {
        dispatch(listFAQs(page));
    }, [dispatch, page, successDelete]);

    const handlePageClick = (event) => {
        setPage(event.selected + 1);
    };

    return (
        <section className="content-main">
            <div className="content-header">
                <Heading as="h2" size="lg" color="teal.600">
                    FAQs
                </Heading>
                <div>
                    <Button as={Link}
                        to="/addfaq" type="submit" colorScheme="teal" _hover={{
                            backgroundColor: "teal.600",
                            color: "white",
                        }}>
                        Create New
                    </Button>
                </div>
            </div>

            <div className="card mb-4 shadow-sm">
                <div className="card-body">
                    {errorDelete && (
                        <Message variant="alert-danger">{errorDelete}</Message>
                    )}
                    {loading ? (
                        <Loading />
                    ) : error ? (
                        <Message variant="alert-danger">{error}</Message>
                    ) : faq.length === 0 ? (
                        <Message variant="alert-info">No FAQs found</Message>
                    ) : (
                        <div className="row">
                            {faq.map((faq) => (
                                <Faq faq={faq} key={faq.id} />
                            ))}
                        </div>
                    )}

                    <ReactPaginate
                        previousLabel={"previous"}
                        nextLabel={"next"}
                        breakLabel={"..."}
                        pageCount={totalPages}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={3}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination justify-content-center"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        previousClassName={"page-item"}
                        previousLinkClassName={"page-link"}
                        nextClassName={"page-item"}
                        nextLinkClassName={"page-link"}
                        breakClassName={"page-item"}
                        breakLinkClassName={"page-link"}
                        activeClassName={"active"}
                        renderOnZeroPageCount={null}
                    />

                </div>
            </div>
        </section>
    );
};

export default MainFaq;
